<template>
	<div class="loginBody">
			
	</div>
		
</template>

<script>
	import {_api} from '@/service/interface'
	import { Indicator } from 'mint-ui';
	export default{
		name: 'auth',
		data(){
			return {
				
			}
		},
		watch:{
			
		},
		created(){
			var href = window.location.href;
			if(href.indexOf("#/auth")==href.length-6){
				 var jingPosit = href.indexOf("com/") + 4; //获取域名结束的位置
		        var urlLeft = href.substring(0, jingPosit);//url左侧部分
		        var routeIndex=href.indexOf("#/");
		        var urlRight =  href.substring(routeIndex, href.length); //url右侧部分
	        	var urlCenter=href.substring(jingPosit, routeIndex);
	        	window.location.href=urlLeft+urlRight+urlCenter
			}else{
				this.auth();
			}
			
		},
		methods:{
			auth(){
				_api('_auth','.code',{params:{code:this.$route.query.code}},res=>{
					if(res.data!=1){
						sessionStorage.setItem("termType",res.data)
						this.$router.push('/point');
					}else{
						this.$router.push('/login')
					}
				},err=>{
				})
			}
				
		},
		mounted(){
			
		}
	}
</script>
<style scoped>
	@import '../../assets/css/style-login.css'
</style>


// WEBPACK FOOTER //
// src/views/auth/auth.vue